import {
  CREATE_LIVE_ACCOUNT,
  CREATE_LIVE_ACCOUNT_SUCCESS,
  CREATE_LIVE_ACCOUNT_FAILURE,
} from "../actionTypes";

export const createLiveAccount = (payload) => ({
  type: CREATE_LIVE_ACCOUNT,
  payload,
});

export const createLiveAccountSuccess = (payload) => ({
  type: CREATE_LIVE_ACCOUNT_SUCCESS,
  payload,
});

export const createLiveAccountFailure = () => ({
  type: CREATE_LIVE_ACCOUNT_FAILURE,
});
